import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('formular', []);
})();
